import { useMutation } from '@tanstack/react-query'
import * as React from 'react'

import { Share as ShareDialog } from '../shared/components/Share'
import { drawShareMap } from '../shared/drawShareMap'
import { colors, sizes } from './selects'
import * as api from './services/api'
import BubbleStore from './stores/bubbleStore'
import { decodeQueryString } from './utils'

interface ShareMapProps {
  extendedFilters?: boolean
  className?: string
}

export function Share(props: ShareMapProps) {
  const uploadImage = useMutation(api.uploadMap)
  const [imageData, setImageData] = React.useState<string | null>(null)

  const onShareClick = React.useCallback(async () => {
    const queryString = decodeQueryString(props.extendedFilters)
    const size = sizes.find((o) => o.value === queryString.size)!.label
    const color = colors.find((o) => o.value === queryString.color)!.label
    const canvas = document.getElementById('bubble-chart-canvas') as HTMLCanvasElement

    const data = await drawShareMap(canvas, [`size: ${size}`, `color: ${color}`, BubbleStore.getDataUpdateTimeString()])

    if (data) {
      uploadImage.mutate({ data, query: window.location.search })
      setImageData(data)
    }
  }, [uploadImage, props.extendedFilters])

  return (
    <ShareDialog
      className={props.className}
      onShareClick={onShareClick}
      state={uploadImage}
      base64ImageData={imageData}
    />
  )
}
